import { render, staticRenderFns } from "./AddCustomerIcon.vue?vue&type=template&id=44a67300&"
import script from "./AddCustomerIcon.vue?vue&type=script&lang=js&"
export * from "./AddCustomerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports